module.exports = __webpack_public_path__ + "static/media/PC7.d2c180da.png";